export default __webpack_public_path__ + "static/media/hht2_sitcom_17.4c8d4577.png";